export default "__VITE_ASSET__DB3I0u$d__"